import React, { useState, useEffect } from 'react';

// --- SwiperJS Imports ---
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';

// --- Image Imports ---
import InteriorImage9 from '../../../assets/Images/Interior9.jpg';
import InteriorImage20 from '../../../assets/Images/Interior20.jpg';
import InteriorImage23 from '../../../assets/Images/Interior23.jpg';
import InteriorImage24 from '../../../assets/Images/Interior24.jpg';
import InteriorImage25 from '../../../assets/Images/Interior25.jpg';
import InteriorImage43 from '../../../assets/Images/Interior43.jpg';
import InteriorImage46 from '../../../assets/Images/Interior46.jpg';
import InteriorImage49 from '../../../assets/Images/Interior49.jpg';
import InteriorImage53 from '../../../assets/Images/Interior53.jpg';
import InteriorImage56 from '../../../assets/Images/Interior56.jpg';
import InteriorImage64 from '../../../assets/Images/Interior64.jpg';
import InteriorImage67 from '../../../assets/Images/Interior67.jpg';
import InteriorImage70 from '../../../assets/Images/Interior70.jpg';
import InteriorImage72 from '../../../assets/Images/Interior72.jpg';
import InteriorImage74 from '../../../assets/Images/Interior74.jpg';
import InteriorImage76 from '../../../assets/Images/Interior76.jpg';
import InteriorImage78 from '../../../assets/Images/Interior78.jpg';
import InteriorImage79 from '../../../assets/Images/Interior79.jpg';
import InteriorImage85 from '../../../assets/Images/Interior85.jpg';
import InteriorImage86 from '../../../assets/Images/Interior86.jpg';
import InteriorImage87 from '../../../assets/Images/Interior87.jpg';
import InteriorImage89 from '../../../assets/Images/Interior89.jpg';
import InteriorImage90 from '../../../assets/Images/Interior90.jpg';
import InteriorImage91 from '../../../assets/Images/Interior91.jpg';
import InteriorImage92 from '../../../assets/Images/Interior92.jpg';
import InteriorImage97 from '../../../assets/Images/Interior97.jpg';
import InteriorImage100 from '../../../assets/Images/Interior100.jpg';
import InteriorImage101 from '../../../assets/Images/Interior101.jpg';
import InteriorImage102 from '../../../assets/Images/Interior102.jpg';
import InteriorImage103 from '../../../assets/Images/Interior103.jpg';
import InteriorImage104 from '../../../assets/Images/Interior104.jpg';
import InteriorImage107 from '../../../assets/Images/Interior107.jpg';
import InteriorImage108 from '../../../assets/Images/Interior108.jpg';
import InteriorImage109 from '../../../assets/Images/Interior109.jpg';
import InteriorImage111 from '../../../assets/Images/Interior111.jpg';
import InteriorImage112 from '../../../assets/Images/Interior112.jpg';
import InteriorImage115 from '../../../assets/Images/Interior115.jpg';
import InteriorImage117 from '../../../assets/Images/Interior117.jpg';
import InteriorImage118 from '../../../assets/Images/Interior118.jpg';

const allImages = [
    InteriorImage9, 
    InteriorImage20, InteriorImage23, InteriorImage24, InteriorImage25, 
    InteriorImage43, InteriorImage46, InteriorImage49, 
    InteriorImage53, InteriorImage56, 
    InteriorImage64, InteriorImage67, InteriorImage70, InteriorImage72, 
    InteriorImage74, InteriorImage76, InteriorImage78, InteriorImage79, 
    InteriorImage85, InteriorImage86, InteriorImage87, 
    InteriorImage89, InteriorImage90, InteriorImage91, InteriorImage92, 
    InteriorImage97, InteriorImage100, InteriorImage101, InteriorImage102, InteriorImage103, InteriorImage104, 
    InteriorImage107, InteriorImage108, InteriorImage109, InteriorImage111, InteriorImage112, 
    InteriorImage115, InteriorImage117, InteriorImage118, 
];

// --- Custom CSS for Animation, Styling, and Color Scheme (Red/Black/White) ---
const GalleryStyles = () => (
    <style>{`
      /* Base SwiperSlide styles */
      .gallery-marquee .swiper-slide {
        width: 320px;
        height: 384px;
        transition: transform 0.5s ease, opacity 0.5s ease;
        opacity: 0.5;
        transform: scale(0.85);
        border-radius: 0.75rem;
        overflow: hidden;
        position: relative;
      }
      /* Active SwiperSlide styles */
      .gallery-marquee .swiper-slide-active {
        opacity: 1;
        transform: scale(1);
      }
      /* Scrollbar hiding styles */
      .hide-scrollbar::-webkit-scrollbar { display: none; }
      .hide-scrollbar { 
        -ms-overflow-style: none;
        scrollbar-width: none;
      }

      /* -------------------------------------------------------- */
      /* Typewriter Effect CSS for Blinking Cursor (Updated Color to Black) */
      /* -------------------------------------------------------- */
      .typewriter-cursor {
          /* Black cursor to match default text color */
          border-right: 3px solid #333; 
          animation: blink-caret 0.75s step-end infinite;
      }
      
      @keyframes blink-caret {
          from, to { border-color: transparent }
          50% { border-color: #333; } /* Blink black */
      }
      
      /* 2. Header Text Styling */
      .gallery-headline {
          font-size: 3rem; /* Desktop default size */
          font-weight: 800; 
          color: #333; /* Default text color is BLACK */
          display: inline-block; 
          cursor: default; 
          transition: color 0.3s ease; 
          white-space: nowrap; /* Crucial for desktop typewriter effect */
          overflow: hidden; /* Crucial for typewriter effect */
          margin-right: 5px; 
      }

      /* 🌟 CRITICAL MOBILE FIX: Force text wrapping and reduce font size on small screens */
      @media (max-width: 639px) { 
          .gallery-headline {
              font-size: 1.75rem; /* Readable size for mobile */
              white-space: normal; /* THIS ENABLES TEXT WRAPPING (Fixes overflow) */
              overflow: visible; /* Allows the wrapped content to be displayed */
              width: 100%; /* Ensure it takes full width of the container for wrapping */
          }
      }
      
      /* Header Hover Color Change (Turns RED on hover) */
      .gallery-headline:hover {
          color: #ff0000; /* Bright Red on hover */
      }

      /* When hovering the headline, we must change the cursor color too */
      .gallery-headline:hover .typewriter-cursor {
          animation: none; /* Stop the default black blink */
          border-right-color: #ff0000; /* Force it to red on hover */
      }
      /* -------------------------------------------------------- */


      /* 5. Creative Card Hover Border Animation */
      .gallery-card-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          cursor: pointer;
          overflow: hidden;
      }
      
      .gallery-card-wrapper::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 0%;
          height: 2px;
          background: #ff0000;
          transition: width 0.3s ease-out, height 0.3s ease-out 0.3s;
          z-index: 10;
      }
      
      .gallery-card-wrapper::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0%;
          height: 2px;
          background: #333;
          transition: width 0.3s ease-out 0.3s, height 0.3s ease-out;
          z-index: 10;
      }

      .gallery-card-wrapper:hover::before { width: 100%; height: 2px; }
      .gallery-card-wrapper:hover::after { width: 100%; height: 2px; }

      .gallery-card-wrapper-vertical-border-left, 
      .gallery-card-wrapper-vertical-border-right {
          content: "";
          position: absolute;
          width: 2px;
          height: 0%;
          transition: height 0.3s ease-out;
          z-index: 10;
      }
      
      .gallery-card-wrapper-vertical-border-left {
          top: 0;
          left: 0;
          background: #333;
      }
      
      .gallery-card-wrapper-vertical-border-right {
          bottom: 0;
          right: 0;
          background: #ff0000;
      }
      
      .gallery-card-wrapper:hover .gallery-card-wrapper-vertical-border-left, 
      .gallery-card-wrapper:hover .gallery-card-wrapper-vertical-border-right {
          height: 100%;
      }
      
      .gallery-card-wrapper img {
          transition: transform 0.5s ease;
      }
      .gallery-card-wrapper:hover img {
          transform: scale(1.05);
      }
      
    `}</style>
  );

const galleryData = allImages.map((src) => ({ src }));


const Gallery = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    
    // --- State for Typewriter Effect ---
    const [typedText, setTypedText] = useState('');
    const [showCursor, setShowCursor] = useState(true);

    const fullHeadline = "Conceptual Gallery: Design Mockups"; // The full text to type
    const typingSpeed = 75; // milliseconds per character

    // --- Typewriter Effect Logic (JS/React) ---
    useEffect(() => {
        let currentText = '';
        let index = 0;
        
        const timer = setInterval(() => {
            if (index < fullHeadline.length) {
                currentText += fullHeadline[index];
                setTypedText(currentText);
                index++;
            } else {
                clearInterval(timer);
                // Keep cursor visible after typing is complete
            }
        }, typingSpeed);

        // Separate interval for cursor blinking after typing finishes
        const cursorTimer = setInterval(() => {
             if (index >= fullHeadline.length) {
                setShowCursor(prev => !prev);
             }
        }, 750); // Blinks at the same rate as the CSS blink-caret keyframe

        return () => {
            clearInterval(timer);
            clearInterval(cursorTimer);
        };
    }, [fullHeadline]);
    // --- End Typewriter Effect Logic ---

    const itemsToDisplay = galleryData;

    const openModal = (src) => {
        setSelectedImage(src);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage('');
    };

    return (
        <>
            <GalleryStyles /> {/* Inject the custom styles */}
            <section id="gallery" className="py-24 overflow-hidden">
                <div className="container mx-auto px-6">
                    <div className="text-center mb-12">
                        {/* HEADER TEXT with Typewriter implementation */}
                        <h2 className="gallery-headline headline-font">
                            {typedText}
                            {/* Conditionally show the blinking cursor span */}
                            {showCursor && <span className="typewriter-cursor"></span>}
                        </h2>

                        {/* UPDATED PARAGRAPH COPY */}
                        <p className="text-xl mt-4 max-w-2xl mx-auto text-gray-700">Explore our conceptual design gallery showcasing a wide range of sleek, modern, and high contrast space mockups. See our vision in creating sophisticated spaces with striking red, black, and white palettes.</p>
                    </div>
                    {/* Removed the filter buttons div entirely */}
                </div>

                <div className="hide-scrollbar">
                    <Swiper
                        key="all-designs-swiper" // Changed key to a static string since filter is removed
                        modules={[Autoplay, EffectCoverflow]}
                        effect="coverflow"
                        loop={true}
                        grabCursor={true}
                        centeredSlides={true}
                        slidesPerView={'auto'}
                        spaceBetween={40}
                        // UPDATED SPEED
                        speed={500} 
                        autoplay={{
                            // UPDATED DELAY (Faster)
                            delay: 1500, 
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true, 
                        }}
                        
                        // ✨ HARD SWIPE / MOMENTUM SETTINGS ✨
                        freeMode={true}
                        watchSlidesProgress={true}
                        freeModeMomentum={true}
                        freeModeMomentumRatio={5} // High ratio for long, fast swipes
                        freeModeMomentumBounce={false} // Stops it from snapping back hard
                        // ✨ END HARD SWIPE SETTINGS ✨

                        coverflowEffect={{
                            rotate: 0,
                            stretch: 0,
                            depth: 100,
                            modifier: 2,
                            slideShadows: false,
                        }}
                        className="gallery-marquee"
                    >
                        {itemsToDisplay.map((item, index) => (
                            <SwiperSlide key={`gallery-item-${index}`} className="rounded-xl overflow-hidden">
                                <div 
                                    className="gallery-card-wrapper w-full h-full shadow-2xl"
                                    onClick={() => openModal(item.src)}
                                >
                                    <div className="gallery-card-wrapper-vertical-border-left"></div>
                                    <div className="gallery-card-wrapper-vertical-border-right"></div>
                                    
                                    <img src={item.src} className="w-full h-full object-cover" alt={`Conceptual interior design mockup: ${item.category || 'all'}`}/>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>

            {/* --- The Lightbox Modal --- */}
            {isModalOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
                    onClick={closeModal}
                >
                    <img 
                        src={selectedImage} 
                        alt="Enlarged view" 
                        className="max-w-[90vw] max-h-[95vh] object-contain rounded-lg shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    />
                     <button 
                            className="absolute top-5 right-5 text-white text-4xl font-bold hover:text-red-500 transition-colors"
                            onClick={closeModal}
                        >
                            &times;
                        </button>
                </div>
            )}
        </>
    );
}

export default Gallery;